export const promiseAll = async promises => await Promise.all(promises)

export const callAsync = async call => await call()

export const log = (...args) => data => {
  console.log.apply(null, args.concat([data]))
  return data
}
